<template>
  <div class="page-combination">
    <swiper class="ships-swiper" :options="shipSwiperOption" v-if="!hasBindTicket">
      <swiper-slide
        :class="['ship-item', {active: item.value === shipActive}]"
        v-for="item in shipList"
        :key="item.value">
        <div @click="shipChange(item.value)">
          <p class="ship-name">{{item.name}}</p>
          <img class="ship-icon" :src="require(`../assets/${item.icon}${item.value === shipActive ? '_cur' : ''}.png`)" alt="">
        </div>
      </swiper-slide>
    </swiper>
    <TabItem :productDetailViewModels="productDetailViewModels" :comboView="comboView"/>
    <OutherSetMeal :comboViewModels="comboViewModels" @changeid="changeId"/>
    <BaseFooter/>
  </div>
</template>

<script>
import api from '@/api'
import { showLoading, hideLoading, showAlert } from '@/utils/tools'
import { shipList } from '@/utils/dict'
import TabItem from './combination/CombinationTabItem.vue'
import OutherSetMeal from './combination/CombinationOutherSetMeal.vue'
import BaseFooter from '@/components/BaseFooter'

export default {
  name: 'PageCombination',

  components: {
    TabItem,
    BaseFooter,
    OutherSetMeal
  },

  data () {
    return {
      shipList,
      shipSwiperOption: {
        freeMode: true,
        slidesPerView: 'auto',
        spaceBetween: 20,
        centerInsufficientSlides: true
      },
      shipActive: null,
      combinationId: null,
      comboViewModels: [],
      productDetailViewModels: [],
      comboView: {}
    }
  },

  activated () {
    if (this.$route.query.id) {
      this.combinationId = this.$route.query.id
      this.shipActive = this.hasBindTicket ? this.$store.state.bindTicket.shipCode : shipList[0].value
      this.getCombList(this.combinationId, this.shipActive)
    }
  },

  computed: {
    hasBindTicket () {
      return Boolean(this.$store.state.bindTicket)
    }
  },

  methods: {
    shipChange (code) {
      // if (this.hasBindTicket) return
      if (code !== this.shipActive) {
        this.shipActive = code
        this.getCombList(this.combinationId, code)
      }
    },
    changeId (id) {
      this.combinationId = id
      this.getCombList(id, this.shipActive)
      window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    },
    // 获取推荐组合列表
    async getCombList (id, shipCode) {
      showLoading()
      const { errCode, errMsg, data } = await api.getCombos({ id: id, ShipCode: shipCode })
      hideLoading()
      if (errCode === 0) {
        this.comboViewModels = data.comboViewModels
        this.productDetailViewModels = data.productDetailViewModels
        this.comboView = data.comboView
      } else {
        showAlert(errMsg)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page-combination{
  .ships-swiper {
    padding: 40px 45px 0px;
    background-color: #fff;
    .ship-item {
      width: 180px;
      height: 103px;
      text-align: center;
      border-bottom: 3px solid #fff;
      &.active {
        border-color: #1174b8;
        .ship-name {
          color: #333;
        }
      }
      .ship-name {
        font-size: 30px;
        color: #999;
        line-height: 44px;
      }
      .ship-icon {
        display: block;
        width: 162px;
        margin: 6px auto 0;
      }
    }
  }
}

</style>
